import { Plot } from '@/components/charts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { TopReplacedCarrier } from '@/hooks/api/useForwardsAnalytics';
import { formatCurrencyCompact } from '@/lib/formatters';

import { baseLayout, blueGradient } from './chart-config';

interface Props {
  data: TopReplacedCarrier[];
}

export function TopReplacedCarriersChart({ data }: Props) {
  const top = data.slice(0, 10);
  const labels = top.map((d) =>
    d.carrierName.length > 28 ? d.carrierName.slice(0, 25) + '...' : d.carrierName
  );

  if (top.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-sm">Top Replaced Carriers</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="py-8 text-center text-sm text-muted-foreground">
            No forwarded recommendations yet
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Top Replaced Carriers</CardTitle>
      </CardHeader>
      <CardContent>
        <Plot
          data={[
            {
              type: 'bar',
              orientation: 'h' as const,
              y: labels,
              x: top.map((d) => d.count),
              marker: {
                color: blueGradient(top.length),
                line: { width: 0 },
              },
              text: top.map((d) => formatCurrencyCompact(d.totalAccountValue)),
              textposition: 'inside' as const,
              textfont: { color: '#ffffff', size: 11 },
              insidetextanchor: 'end' as const,
              hovertemplate: top.map(
                (d) =>
                  `${d.carrierName}<br>` +
                  `Replacements: %{x}<br>` +
                  `Total Value: ${formatCurrencyCompact(d.totalAccountValue)}<extra></extra>`
              ),
            },
          ]}
          layout={baseLayout({
            margin: { l: 180, r: 20, t: 10, b: 40 },
            xaxis: {
              title: { text: 'Replacement Count' },
              gridcolor: 'rgba(148,163,184,0.15)',
            },
            yaxis: {
              autorange: 'reversed',
              gridcolor: 'rgba(148,163,184,0.15)',
              ticksuffix: '  ',
            },
            barcornerradius: 4,
          })}
          config={{ displayModeBar: false, responsive: true }}
          useResizeHandler
          className="h-64 w-full"
        />
      </CardContent>
    </Card>
  );
}
